import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class LiveHandoffMessageRecord
 * @augments BaseMessageRecord
 */
class LiveHandoffMessageRecord extends BaseMessageRecord({
  type: "live_handoff",

  /**
   * @memberof LiveHandoffMessageRecord#
   */
  fallbackResponseId: null
}) {}

/**
 * Validation
 */

/**
 * @param {LiveHandoffMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
LiveHandoffMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.fallbackResponseId) {
    invalidFields.add("fallbackResponseId");
  }

  return Immutable.List(invalidFields);
};

export default LiveHandoffMessageRecord;
